export default __webpack_public_path__ + "static/media/Genset-image-SE.f0c4f48e.jpg";